import { IStepOption } from 'ngx-ui-tour-md-menu';

import { TourKeys, TourType } from '../enums/tour.enum';
import { Tour } from '../interfaces/tour.interface';

import { PAGES } from '@/enums/pages.enum';

const WALKTHROUGH_HOME_STEPS: IStepOption[] = [
  {
    anchorId: 'rounded-menu-anchor',
    title: 'WALKTHROUGH.STEP_TWO.TITLE',
    content: 'WALKTHROUGH.STEP_TWO.DESCRIPTION',
    isAsync: true,
    backdropConfig: { offset: 18 }
  },
  {
    anchorId: 'profile-anchor',
    title: 'WALKTHROUGH.STEP_THREE.TITLE',
    content: 'WALKTHROUGH.STEP_THREE.DESCRIPTION',
    placement: { yPosition: 'above' },
    backdropConfig: { offset: 9 },
    popoverClass: 'tour-profile-popover'
  }
];

const NEWS_MOMO_SCHEDULE: IStepOption[] = [
  {
    anchorId: 'momo-schedule-anchor',
    title: 'NEWS.MOMO_SCHEDULE.TITLE',
    content: 'NEWS.MOMO_SCHEDULE.SUBTITLE',
    closeOnOutsideClick: true,
    isAsync: true,
    backdropConfig: { offset: 18 }
  }
];

export const TOURS: Tour[] = [
  {
    keyName: TourKeys.HOME,
    section: PAGES.HOME,
    steps: WALKTHROUGH_HOME_STEPS,
    type: TourType.WALKTHROUGH
  },
  {
    keyName: TourKeys.MOMO_SCHEDULE,
    section: PAGES.HOME,
    steps: NEWS_MOMO_SCHEDULE,
    type: TourType.NEWS
  }
];
